import styled from 'styled-components';

const Quantity = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold}
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

export default Quantity;
